"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MarkAsRead = exports.FlyoutActions = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
require("./PulseNotificationMessage.scss");
require("./PulseMessage.scss");
var _Close = _interopRequireDefault(require("@react/react-spectrum/Icon/Close"));
var _Button = _interopRequireDefault(require("@react/react-spectrum/Button"));
var _CheckmarkCircle = _interopRequireDefault(require("@react/react-spectrum/Icon/CheckmarkCircle"));
var _OverlayTrigger = _interopRequireDefault(require("@react/react-spectrum/OverlayTrigger"));
var _Tooltip = _interopRequireDefault(require("@react/react-spectrum/Tooltip"));
var _PulseUtil = _interopRequireDefault(require("../../util/PulseUtil"));
var _MarkAsRead = _interopRequireDefault(require("../../actions/MarkAsRead"));
var _Reminders = _interopRequireDefault(require("../../actions/Reminders"));
var types = _interopRequireWildcard(require("../../store/actions/actionTypes"));
var _classnames = _interopRequireDefault(require("classnames"));
var _RemindersDropDown = _interopRequireDefault(require("./RemindersDropDown"));
var _Constants = require("../../constants/Constants");
var _reactIntl = require("react-intl");
var _IconMapper = _interopRequireDefault(require("../icons/IconMapper"));
var _reactRedux = require("react-redux");
var _metrics = _interopRequireDefault(require("../../custom-hooks/metrics"));
var _intl = require("@quarry/intl");
var localizationStrings = _interopRequireWildcard(require("./__localization__/RemindersDropDown"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any. The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/

const mapStateToProps = () => ({});
const mapDispatchToProps = dispatch => ({
  dispatchToToggleReadStatus: notification => dispatch((0, _MarkAsRead.default)(notification)),
  dispatchToSetReminder: (notification, serverTime, reminderTime) => dispatch(_Reminders.default.setReminder(notification, serverTime, reminderTime)),
  dispatchToRemoveReminder: notification => dispatch(_Reminders.default.removeReminder(notification)),
  dispatchToMarkReminderAsShown: id => {
    dispatch({
      type: types.MARK_REMINDER_AS_SHOWN,
      ids: [id]
    });
  },
  dispatchToMarkNotificationAsShown: id => {
    dispatch({
      type: types.MARK_NOTIFICATIONS_AS_SHOWN,
      ids: [id]
    });
  },
  dispatchToSetNotificationURLValidity: flag => {
    dispatch({
      type: types.NOTIFICATION_URL_LINK_VALIDATION,
      payload: flag
    });
  }
});
const pushMetrics = (metrics, isFloatingAlert, isReminder) => {
  if (isFloatingAlert) {
    metrics.event('flyout.floatingAlert.markAsRead.click', {
      region: window.config && window.config.region
    });
  } else if (isReminder) {
    metrics.event('flyout.reminder.markAsRead.click', {
      region: window.config && window.config.region
    });
  } else {
    metrics.event('flyout.notifications.markAsRead.click', {
      region: window.config && window.config.region
    });
  }
};
const PriorityFlag = props => {
  const {
    formatMessage
  } = props;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "pulse-notification-message-priority-tag"
  }, formatMessage({
    id: 'High',
    defaultMessage: 'High',
    description: 'High'
  }));
};
const TimeAgo = props => {
  const {
    createdTimestamp
  } = props;
  return /*#__PURE__*/_react.default.createElement(_OverlayTrigger.default, {
    delayShow: _Constants.TOOLTIP_DELAY_ON_ACTIONS_BUTTON,
    placement: "top",
    trigger: "hover"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pulse-notification-message-time-ago"
  }, _PulseUtil.default.formatTimeAgo(createdTimestamp, true)), /*#__PURE__*/_react.default.createElement(_Tooltip.default, null, _PulseUtil.default.formatDate(createdTimestamp)));
};
const MarkAsRead = props => {
  const {
    pulseMessageObject,
    isFloatingAlert,
    isReminder,
    formatMessage,
    metrics,
    dispatchToMarkReminderAsShown,
    dispatchToToggleReadStatus
  } = props;
  /**
   * This function will mark the notification as read
   * and will revert the store changes if the API
   * call was unsuccessful.
   * @param event
   */
  const handleClickOnMarkAsRead = async event => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    pushMetrics(metrics, isFloatingAlert, isReminder);
    const success = await dispatchToToggleReadStatus(pulseMessageObject);
    if (success && isReminder) {
      dispatchToMarkReminderAsShown(pulseMessageObject.id);
    }
  };
  return /*#__PURE__*/_react.default.createElement(_OverlayTrigger.default, {
    delayShow: _Constants.TOOLTIP_DELAY_ON_ACTIONS_BUTTON,
    placement: "top",
    trigger: "hover"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pulse-notification-message-actions-button"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: "notification-mark-as-read-button",
    icon: /*#__PURE__*/_react.default.createElement(_CheckmarkCircle.default, {
      size: "S"
    }),
    label: null,
    onClick: async event => await handleClickOnMarkAsRead(event),
    quiet: true,
    variant: "action"
  })), /*#__PURE__*/_react.default.createElement(_Tooltip.default, null, pulseMessageObject.isRead ? formatMessage({
    id: 'markAsUnead',
    defaultMessage: 'Mark as unread',
    description: 'Mark as unread'
  }) : formatMessage({
    id: 'markAsRead',
    defaultMessage: 'Mark as read',
    description: 'Mark as read'
  })));
};
exports.MarkAsRead = MarkAsRead;
const CrossButton = props => {
  const {
    pulseMessageObject,
    isReminder,
    isFloatingAlert,
    onMessageCloseClicked,
    formatMessage,
    metrics,
    dispatchToMarkNotificationAsShown,
    dispatchToMarkReminderAsShown
  } = props;
  const handleClickOnCrossButton = event => {
    event.preventDefault();
    if (isReminder) {
      metrics.event('flyout.reminder.closed', {
        region: window.config && window.config.region
      });
      dispatchToMarkReminderAsShown(pulseMessageObject.id);
    }
    if (isFloatingAlert) {
      dispatchToMarkNotificationAsShown(pulseMessageObject.id);
      onMessageCloseClicked();
    }
  };
  return /*#__PURE__*/_react.default.createElement(_OverlayTrigger.default, {
    delayShow: _Constants.TOOLTIP_DELAY_ON_ACTIONS_BUTTON,
    offset: 10,
    placement: "top",
    trigger: "hover"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pulse-notification-message-actions-button"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    icon: /*#__PURE__*/_react.default.createElement(_Close.default, {
      size: "S"
    }),
    label: null,
    onClick: handleClickOnCrossButton,
    quiet: true,
    variant: "action"
  })), /*#__PURE__*/_react.default.createElement(_Tooltip.default, null, isReminder ? formatMessage({
    id: 'DismissReminder',
    defaultMessage: 'Dismiss reminder',
    description: 'Dismiss reminder'
  }) : formatMessage({
    id: 'DismissAlert',
    defaultMessage: 'Dismiss',
    description: 'Dismiss'
  })));
};
const SnoozeButton = props => {
  const {
    pulseMessageObject,
    isReminder,
    setReminderDropdownOpen,
    serverTimeStamp,
    clientTimeStamp,
    metrics,
    dispatchToMarkReminderAsShown,
    dispatchToSetReminder,
    dispatchToRemoveReminder,
    locale
  } = props;
  const isReminderActive = pulseMessageObject.reminderTime && pulseMessageObject.reminderTime > _PulseUtil.default.getServerTimeFromNow(serverTimeStamp, clientTimeStamp);
  return /*#__PURE__*/_react.default.createElement(_intl.IntlProvider, {
    locale: locale,
    messages: localizationStrings
  }, /*#__PURE__*/_react.default.createElement(_RemindersDropDown.default, {
    isReminderActive: isReminderActive,
    onReminderDeleted: async () => {
      dispatchToRemoveReminder(pulseMessageObject);
      if (isReminder) {
        dispatchToMarkReminderAsShown(pulseMessageObject.id);
      }
    },
    onReminderDropDownClose: () => {
      setReminderDropdownOpen(false);
    },
    onReminderDropDownOpen: () => {
      setReminderDropdownOpen(true);
    },
    onReminderSelected: futureTime => {
      const serverTime = _PulseUtil.default.getServerTimeFromNow(serverTimeStamp, clientTimeStamp);
      dispatchToSetReminder(pulseMessageObject, serverTime, futureTime);
      //TODO: Duplicate event. Need to remove.
      metrics.event('notification.reminder.set', {
        region: window.config && window.config.region
      });
      if (isReminder) {
        //push metrics for setting `reminder` on existing displayed reminders
        metrics.event('notification.reminder.onReminder.set', {
          region: window.config && window.config.region
        });
        dispatchToMarkReminderAsShown(pulseMessageObject.id);
      }
    },
    reminderTime: pulseMessageObject.reminderTime
  }));
};
const FloatingActions = props => {
  const {
    hoverStatus,
    isReminderDropDownOpen,
    pulseMessageObject
  } = props;
  const style = 'pulse-notification-message-actions-bar';
  return /*#__PURE__*/_react.default.createElement("div", {
    className: style
  }, /*#__PURE__*/_react.default.createElement(TimeAgo, {
    createdTimestamp: pulseMessageObject.createdTimestamp
  }), (hoverStatus || isReminderDropDownOpen) && /*#__PURE__*/_react.default.createElement(SnoozeButton, props), /*#__PURE__*/_react.default.createElement(CrossButton, props));
};
const FlyoutActions = props => {
  const {
    hoverStatus,
    isReminderDropDownOpen,
    pulseMessageObject,
    serverTimeStamp,
    clientTimeStamp
  } = props;
  const style = 'pulse-notification-message-actions-bar';
  const isReminderActive = pulseMessageObject.reminderTime && pulseMessageObject.reminderTime > _PulseUtil.default.getServerTimeFromNow(serverTimeStamp, clientTimeStamp);
  if (hoverStatus || isReminderDropDownOpen) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: style
    }, !pulseMessageObject.fromReminder && /*#__PURE__*/_react.default.createElement(MarkAsRead, props), /*#__PURE__*/_react.default.createElement(SnoozeButton, props), /*#__PURE__*/_react.default.createElement(TimeAgo, {
      createdTimestamp: pulseMessageObject.createdTimestamp
    }));
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: style
  }, isReminderActive && /*#__PURE__*/_react.default.createElement(SnoozeButton, props), /*#__PURE__*/_react.default.createElement(TimeAgo, {
    createdTimestamp: pulseMessageObject.createdTimestamp
  }));
};
exports.FlyoutActions = FlyoutActions;
const Avatar = props => {
  const {
    pulseMessageObject
  } = props;
  return /*#__PURE__*/_react.default.createElement(_OverlayTrigger.default, {
    delayShow: _Constants.TOOLTIP_DELAY_ON_AVATAR,
    placement: "top",
    trigger: "hover"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pulse-message-avatar"
  }, pulseMessageObject.isUser ? /*#__PURE__*/_react.default.createElement("img", {
    alt: "avatar",
    className: "pulse-notification-user-avatar",
    src: pulseMessageObject.avatar ? pulseMessageObject.avatar : _Constants.DEFAFULT_AVATAR_URL
  }) :
  /*#__PURE__*/
  //TODO: Need to check if avatar is a string or an object
  _react.default.createElement(_IconMapper.default, {
    product: pulseMessageObject.product ? pulseMessageObject.product : 'Experience Cloud'
  })), /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    className: "avatar-tooltip-label"
  }, pulseMessageObject.isUser ? `${pulseMessageObject.firstName} ${pulseMessageObject.lastName}` : pulseMessageObject.product));
};
const Actions = props => {
  const {
    formatMessage
  } = props;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "pulse-notification-message-row3"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pulse-notification-message-action-buttons-right"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: "pulse-notification-message-reject-button",
    quiet: true,
    variant: "primary"
  }, formatMessage({
    id: 'Reject',
    defaultMessage: 'Reject',
    description: 'Reject'
  })), /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: "pulse-notification-message-approve-button",
    quiet: true,
    variant: "primary"
  }, formatMessage({
    id: 'Approve',
    defaultMessage: 'Approve',
    description: 'Approve'
  }))));
};
const PulseNotificationMessage = props => {
  const {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    pulseMessageObject,
    isFloatingAlert,
    renderCrossButton,
    isReminder,
    intl,
    serverTimeStamp,
    clientTimeStamp,
    onMessageCloseClicked = () => {},
    dispatchToSetNotificationURLValidity,
    dispatchToToggleReadStatus,
    dispatchToMarkReminderAsShown,
    dispatchToMarkNotificationAsShown,
    dispatchToSetReminder,
    dispatchToRemoveReminder
  } = props;
  const {
    locale,
    formatMessage
  } = intl;
  const [hoverStatus, setHoverStatus] = (0, _react.useState)(false);
  const buttonRef = (0, _react.useRef)();
  const [isReminderDropDownOpen, setReminderDropdownOpen] = (0, _react.useState)(false);
  const textRef = (0, _react.useRef)(null);
  const productRef = (0, _react.useRef)(null);
  const [showProductTooltip, setShowProductTooltip] = (0, _react.useState)(false);
  const backgroundStyle = pulseMessageObject.isRead || isFloatingAlert ? 'pulse-notification-read-background' : 'pulse-notification-unread-background';
  const metrics = (0, _metrics.default)('exc.pulse.components.message.PulseNotificationMessage');
  const mouseEnterHandler = () => {
    setShowProductTooltip(_PulseUtil.default.isTextOverFlown(productRef));
  };
  const onNotificationClick = async () => {
    metrics.event('notification.navigationLink.click', {
      region: window.config && window.config.region,
      type: pulseMessageObject.type,
      subtype: pulseMessageObject.subtype,
      product: pulseMessageObject.product
    });
    const validUrl = _PulseUtil.default.validateUrl(pulseMessageObject.url);
    dispatchToSetNotificationURLValidity(validUrl);
    !validUrl && setTimeout(() => dispatchToSetNotificationURLValidity(!validUrl), 3000);
    if (isReminder) {
      dispatchToMarkReminderAsShown(pulseMessageObject.id);
    }
    if (!pulseMessageObject.isRead || pulseMessageObject.fromReminder) {
      dispatchToToggleReadStatus(pulseMessageObject);
      const success = await (0, _MarkAsRead.default)(pulseMessageObject);
      if (success) {
        dispatchToMarkNotificationAsShown(pulseMessageObject.id);
      }
    }
  };
  const onKeyDownSpace = event => {
    if (event.target !== buttonRef.current) {
      return;
    }
    if (event.key === ' ' || event.key === 'Enter') {
      event.preventDefault();
      buttonRef.current.click();
    }
  };
  const showToolTip = _PulseUtil.default.isTextOverFlown(textRef);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('pulse-notification-message-root', backgroundStyle),
    onMouseEnter: () => setHoverStatus(true),
    onMouseLeave: () => setHoverStatus(false),
    onMouseMove: () => setHoverStatus(true)
  }, /*#__PURE__*/_react.default.createElement("a", (0, _extends2.default)({
    onClick: onNotificationClick,
    onKeyDown: onKeyDownSpace,
    ref: buttonRef,
    role: "button",
    style: {
      textDecoration: 'none',
      color: 'inherit'
    },
    tabIndex: 0
  }, _PulseUtil.default.validateUrl(pulseMessageObject.url) && {
    href: pulseMessageObject.url
  }, _PulseUtil.default.validateUrl(pulseMessageObject.url) && {
    target: '_blank'
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "pulse-notification-message-row1"
  }, pulseMessageObject.priority === 'high' && /*#__PURE__*/_react.default.createElement(PriorityFlag, {
    formatMessage: formatMessage
  }), /*#__PURE__*/_react.default.createElement(_OverlayTrigger.default, {
    delayShow: _Constants.TOOLTIP_DELAY_ON_MESSAGE,
    placement: "top",
    trigger: "hover"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pulse-notification-message-product-name avatar-tooltip-label",
    onMouseEnter: mouseEnterHandler,
    ref: productRef
  }, ' ', pulseMessageObject.product), /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    style: showProductTooltip ? {
      visibility: 'visible'
    } : {
      visibility: 'hidden'
    }
  }, ' ', pulseMessageObject.product)), isFloatingAlert || renderCrossButton ? /*#__PURE__*/_react.default.createElement(FloatingActions, {
    clientTimeStamp: clientTimeStamp,
    dispatchToMarkNotificationAsShown: dispatchToMarkNotificationAsShown,
    dispatchToMarkReminderAsShown: dispatchToMarkReminderAsShown,
    dispatchToRemoveReminder: dispatchToRemoveReminder,
    dispatchToSetReminder: dispatchToSetReminder,
    formatMessage: formatMessage,
    hoverStatus: hoverStatus,
    isFloatingAlert: isFloatingAlert,
    isReminder: isReminder,
    isReminderDropDownOpen: isReminderDropDownOpen,
    locale: locale,
    metrics: metrics,
    onMessageCloseClicked: onMessageCloseClicked,
    pulseMessageObject: pulseMessageObject,
    serverTimeStamp: serverTimeStamp,
    setReminderDropdownOpen: setReminderDropdownOpen
  }) : /*#__PURE__*/_react.default.createElement(FlyoutActions, {
    clientTimeStamp: clientTimeStamp,
    dispatchToMarkReminderAsShown: dispatchToMarkReminderAsShown,
    dispatchToRemoveReminder: dispatchToRemoveReminder,
    dispatchToSetReminder: dispatchToSetReminder,
    dispatchToToggleReadStatus: dispatchToToggleReadStatus,
    formatMessage: formatMessage,
    hoverStatus: hoverStatus,
    isFloatingAlert: isFloatingAlert,
    isReminder: isReminder,
    isReminderDropDownOpen: isReminderDropDownOpen,
    locale: locale,
    metrics: metrics,
    pulseMessageObject: pulseMessageObject,
    serverTimeStamp: serverTimeStamp,
    setReminderDropdownOpen: setReminderDropdownOpen
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "pulse-notification-message-row2"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pulse-notification-message-row2-col1"
  }, /*#__PURE__*/_react.default.createElement(Avatar, {
    pulseMessageObject: pulseMessageObject
  })), /*#__PURE__*/_react.default.createElement(_OverlayTrigger.default, {
    delayShow: _Constants.TOOLTIP_DELAY_ON_MESSAGE,
    placement: "right",
    trigger: "hover"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pulse-notification-message-row2-col2",
    ref: textRef
  }, /*#__PURE__*/_react.default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: pulseMessageObject.text
    }
  })), /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    style: showToolTip ? {
      visibility: 'visible'
    } : {
      visibility: 'hidden'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: pulseMessageObject.text
    }
  })))), pulseMessageObject.isActionable && /*#__PURE__*/_react.default.createElement(Actions, {
    formatMessage: formatMessage
  })));
};
var _default = (0, _reactIntl.injectIntl)((0, _reactRedux.connect)(null, mapDispatchToProps)(PulseNotificationMessage));
exports.default = _default;